import React from 'react';

class ListItem extends React.Component {
  constructor(props) {
   super(props);
  }

  render(){

    const {name,info,mix} = this.props;

    return (
      <li className="product-list-item">
        <div className="product-list-item-text">
          <h4>{name}</h4>
          <p>{info}</p>
        </div>
        {this.renderIcon()}
      </li>
    );
  }

  renderIcon(){
    let mix = this.props.mix;
    if(mix == null){
      return (
          <span className="product-icon-neutral"><i className="fas fa-minus"></i></span>
      );
    }else if(mix == true){
      return (
          <span className="product-icon-done"><i className="fas fa-check"></i></span>
      );
    }else{
      return (
        <span className="product-icon-error"><i className="fas fa-times"></i></span>
      );
    }
  }
}


export default ListItem;
